import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag"
import { windowUpdate, removeReCaptchaBadge } from './shared/common'
// controllers
import Controller from './controllers/Controller'
import HomeController from './controllers/HomeController'
import HomeSidebarController from './controllers/HomeSidebarController'
import CommentQuoteController from './controllers/CommentQuoteController'
import SearchResultsController from './controllers/SearchResultsController'
// views
// import View from './views/View'

const routes = {
  'webflow': {
    controller: Controller,
    view: RytmWebflow.WebflowView
  },
  'list': {
    controller: Controller,
    view: RytmWebflow.WebflowListView
  },
  'search': {
    controller: SearchResultsController,
    view: RytmWebflow.WebflowListView
  },
  'home' : {
    controller: HomeController,
    view: RytmWebflow.WebflowView
  },
  'homeSidebar' : {
    controller: HomeSidebarController,
    view: null
  },
  'commentQuote' : {
    controller: CommentQuoteController,
    view: null
  },
}
const aswapProps = {
  animationTimeHide: 600,
  animationTimeShow: 600,
  preloadOnHover: false,
  cacheOn: true,
  refreshOnSameUrl: false,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    WCAG.onViewChanged()
    windowUpdate()
    RytmWebflow.showUp.rebuild()
  },
  onViewHide: () => {
    WCAG.dialogCloseAll()
    removeReCaptchaBadge()
    // RytmWebflow.showUp.hide()
    RytmWebflow.bootsrap5.hideFlyovers()
  },
  onViewHidden: () => {
    // destroy...
  },
  onRequestSameUrl: () => {
    // same url request
    RytmWebflow.bootsrap5.hideFlyovers();
  },
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}